export default "__VITE_ASSET__C$Gj_nor__"